export const fetchCard = async (fname) => {
  const [name, set, number] = fname.split('|')
  const url = `https://json.edhrecstatic.com/cards/${[formatUrl(name), formatUrl(set || ''), formatUrl(number || '')]
    .filter(Boolean)
    .join('/')}`
  const promise_array = [fetch(url)]

  if (window.location.href.includes('cardsphere')) {
    const cs_res = fetch('https://www.cardsphere.com/rest/v1/cardinfo/resolve', {
      method: "POST",
      body: JSON.stringify([name]),
      headers: {"Content-type": 'application/json'}
    })
    promise_array.push(cs_res)
  }
  const [edhrec, cs] = await Promise.all(promise_array)
  const json = await edhrec.json()

  if (cs) {
    const cs_json = await cs.json()
    json.url = cs_json[0].url
    json.cardsphere = true
  }
  return json
}

const formatUrl = (str) =>
  str
    .normalize('NFD')
    .toLowerCase()
    .replaceAll(/[^a-zA-Z0-9-_+\s/]/g, '')
    .replaceAll('+', 'plus ')
    .replaceAll(/[\s/]+/g, '-')
